// @flow
import React, { Fragment } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { MdPlayCircleFilled } from 'react-icons/lib/md';

import * as styles from './logincontent.css';

type LoginContentPropTypes = {
};

const LoginContent = ({
}: LoginContentPropTypes) => (
  <Fragment>
    <div className={styles.textcontent}>
      <span className={styles.title}>
        {'¡Obtén el control '}
        <span>
          {'de tus buses escolares!'}
        </span>
      </span>
    </div>
    <div
      className={`${styles.textcontent} ${styles.strech}`}>
      <h2>
        {'Trackea el bus escolar en el que van tus hijos mientras dura el viaje, solicita cambios de parada y controla quién puede recoger a tus hijos.'}
      </h2>
    </div>
    <div className={styles.textcontent}>
      <a href="https://onthebus.io" target="_blank">
        <MdPlayCircleFilled size={24}/>
        {' visita nuestro sitio'}
      </a>
    </div>
  </Fragment>
);

export default LoginContent;



// WEBPACK FOOTER //
// ./src/scripts/components/LoginContent/index.jsx